(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["custom-ces-product-bundle"] && !Shopify.designMode) return;
  try {
    window.bundleAddToCart = async (
    items,
    openCartDrawer = false,
    clearCart = false,
  ) => {
    try {
      if (clearCart) {
        await fetch(theme.routes.cart_clear_url, { method: 'POST' });
      }

      const cartDrawer = document.querySelector('cart-drawer');
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        }),
      );
      const data = JSON.stringify({
        items,
        sections: sectionsToBundle,
        sections_url: window.location.pathname,
      });

      const parsedState = await fetch(theme.routes.cart_add_url, {
        ...theme.utils.fetchConfig('javascript'),
        body: data,
      }).then((res) => res.json());

      const cartJson = await fetch(theme.routes.cart_url, {
        ...theme.utils.fetchConfig('json', 'GET'),
      }).then((res) => res.json());

      cartJson['sections'] = parsedState['sections'] || [];
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: 'add-to-cart',
        cart: cartJson,
      });

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: { product: parsedState },
        }),
      );
      if (openCartDrawer) {
        cartDrawer?.show();
      }
    } catch (error) {}
  };

  window.bundleBuyNow = (items, promo_code) => {
    if (promo_code) {
      window.location.href = `${theme.routes.cart_url}/checkout?discount=${promo_code}`;
    } else {
      window.location.href = `${theme.routes.cart_url}/checkout`;
    }
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-ces-product-item-image"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const image = document.querySelectorAll(
      '.custom-ces-product-item-image[data-hover-video="true"]',
    );
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    image.forEach((item) => {
      item.addEventListener('mouseenter', function () {
        if (isMobile) {
          return;
        }
        this.querySelector('video').play();
      });
      item.addEventListener('mouseleave', function () {
        if (isMobile) {
          return;
        }
        this.querySelector('video').pause();
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custom-ces-product-item"] && !Shopify.designMode) return;
  try {
    window.preorderAddToCart = async (items) => {
    try {
      const cartDrawer = document.querySelector('cart-drawer');
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        }),
      );
      const data = JSON.stringify({
        items,
        sections: sectionsToBundle,
        sections_url: window.location.pathname,
      });

      const parsedState = await fetch(theme.routes.cart_add_url, {
        ...theme.utils.fetchConfig('javascript'),
        body: data,
      }).then((res) => res.json());

      const cartJson = await fetch(theme.routes.cart_url, {
        ...theme.utils.fetchConfig('json', 'GET'),
      }).then((res) => res.json());

      cartJson['sections'] = parsedState['sections'] || [];
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: 'add-to-cart',
        cart: cartJson,
      });

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: { product: parsedState },
        }),
      );
      cartDrawer?.show();
    } catch (error) {}
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["custome-product-list-tab"] && !Shopify.designMode) return;
  try {
    window.initCustomProductListTab = (id, isAutoplay, autoplayTime) => {
    const swiper = new Swiper(`#${id}`, {
      slidesPerView: 'auto',
      autoplay: isAutoplay
        ? {
            delay: autoplayTime,
            disableOnInteraction: false,
          }
        : false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  };
  } catch(e) { console.error(e); }
})();

})();
